import React from "react";

import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../../styles/new-search-widget.module.scss";
import {KeyboardArrowLeft} from "../../../../core/icons/keyboard-arrow/keyboard-arrow-left";
import {KeyboardArrowRight} from "../../../../core/icons/keyboard-arrow/keyboard-arrow-right";
import {NEW_SEARCH_WIDGET} from "../../new-search-widget.consts";

export const NewSearchWidgetEntitiesSeeAll = observer(({controller, listModel, isRecentSearchesList}) => {
  const {state, device, terms} = controller;
  const {isListSingleView} = state;
  const {isSmallView, isRtl} = device;
  const {SEE_ALL} = terms;

  const shouldRenderSeeAll: Boolean = isSmallView && !isListSingleView && !isRecentSearchesList && listModel?.entities?.length > NEW_SEARCH_WIDGET.mobilePreviewTopEntities

  const containerProps = {
    className: classNames(styles.see_all),
    onClick: () => controller.action(NEW_SEARCH_WIDGET.ACTION_TYPES.CLICK.onSeeAllClick, {id: listModel?.id})
  }

  return shouldRenderSeeAll ? <div {...containerProps}>
    {SEE_ALL}
    {
      isRtl ? <KeyboardArrowLeft className={classNames(styles.arrow)}/> :
        <KeyboardArrowRight className={classNames(styles.arrow)}/>
    }
  </div> : null
});
